import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
interface SummonerSpell {
  id: number;
  name: string;
  description: string;
  summonerLevel: number;
  cooldown: number;
  gameModes: string[];
  iconPath: string;
}
const fetchSummonerSpells = async (): Promise<SummonerSpell[]> => {
  const response = await fetch("https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/summoner-spells.json");
  if (!response.ok) {
    throw new Error("Failed to fetch summoner spells");
  }
  return response.json();
};
export const useSummonerSpells = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["summoner-spells"],
      queryFn: fetchSummonerSpells,
      staleTime: 3600000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
};